import {
  collection,
  doc,
  getDoc,
  getDocs,
  limit,
  query,
  setDoc,
  updateDoc,
  where,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase/config";

const COLLECTION = "organizationMemberships";

function membershipRef(membershipId) {
  return doc(db, COLLECTION, membershipId);
}

export async function fetchMembership(membershipId) {
  if (!membershipId) return null;
  const snap = await getDoc(membershipRef(membershipId));
  if (!snap.exists()) return null;
  return { id: snap.id, membershipId: snap.id, ...snap.data() };
}

export async function createMembership(membershipId, data) {
  await setDoc(membershipRef(membershipId), {
    ...data,
    membershipId,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
}

export async function updateMembership(membershipId, data) {
  await updateDoc(membershipRef(membershipId), {
    ...data,
    updatedAt: serverTimestamp(),
  });
}

/**
 * @param {string} organizationId
 * @param {{ max?: number, status?: string }} [options]
 */
export async function listMembershipsForOrganization(organizationId, options = {}) {
  if (!organizationId) return [];
  const max = Math.min(options.max || 100, 150);
  const constraints = [
    where("organizationId", "==", organizationId),
    limit(max),
  ];
  const snap = await getDocs(query(collection(db, COLLECTION), ...constraints));
  let rows = snap.docs.map((d) => ({ id: d.id, membershipId: d.id, ...d.data() }));
  if (options.status) {
    rows = rows.filter((r) => r.status === options.status);
  }
  return rows;
}

/**
 * @param {string} userId
 * @param {{ max?: number }} [options]
 */
export async function listMembershipsForUser(userId, options = {}) {
  if (!userId) return [];
  const max = Math.min(options.max || 40, 80);
  const snap = await getDocs(
    query(collection(db, COLLECTION), where("userId", "==", userId), limit(max))
  );
  return snap.docs.map((d) => ({ id: d.id, membershipId: d.id, ...d.data() }));
}

/**
 * @param {string} organizationId
 * @param {string} userId
 */
export async function findMembershipForUser(organizationId, userId) {
  if (!organizationId || !userId) return null;
  const snap = await getDocs(
    query(
      collection(db, COLLECTION),
      where("organizationId", "==", organizationId),
      where("userId", "==", userId),
      limit(5)
    )
  );
  const rows = snap.docs.map((d) => ({ id: d.id, membershipId: d.id, ...d.data() }));
  return (
    rows.find((r) => r.status === "active" || r.status === "pending") ||
    rows[0] ||
    null
  );
}

export { COLLECTION as ORGANIZATION_MEMBERSHIPS_COLLECTION };
